import { ledgermasterservice } from "@/api/services/accountService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

interface Ledger {
  id: string;
  accountCode: string;
  ledgerName: string;
  groupId: string;
//   group: string;
//   masterGroupId: string;
//   masterGroup: string;
//   ledgerType: string;
//   status: number;
//   creditLimit: number;
//   debitLimit: number;
//   financialYearId: string;
//   finYearCode: string;
}

interface LedgerMasterState {
  loading: boolean;
  ledgerList: Ledger[];
  error?: string;
}

const initialState: LedgerMasterState = {
  loading: false,
  ledgerList: [],
  error: undefined,
};

export const fetchLedgerMaster = createAsyncThunk<
  Ledger[],
  void,
  { rejectValue: string }
>("ledger/fetchLedgerMaster", async (_, { rejectWithValue }) => {
  try {
    const response = await ledgermasterservice.getall();
    return response.data?.ledgerDatas ?? response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch ledger data");
  }
});

const LedgerMasterSlice = createSlice({
  name: "LedgerMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLedgerMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        fetchLedgerMaster.fulfilled,
        (state, action: PayloadAction<Ledger[]>) => {
          state.ledgerList = action.payload;
          state.loading = false;
        }
      )
      .addCase(fetchLedgerMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default LedgerMasterSlice.reducer;
